import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import UsersList from './UsersList';
import { Breadcrumbs } from '../../../AbstractElements';


const BasicTables = () => {
    return (
        <Fragment>
            <Breadcrumbs title="Users" mainTitle='' />
            <Container fluid={true}>
                <Row>
                    <UsersList />
                </Row>
            </Container>
        </Fragment>
    );
};

export default BasicTables;